<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.workday.searchText')"
                        solo
                        height="40px"
                        @keyup.enter="searchWorkdays()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        height="40px"
                        color="primary"
                        outlined
                        @click="searchWorkdays()">
                        {{ $vuetify.lang.t('$vuetify.workday.search') }}
                    </v-btn>
                </div>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalWorkday"
                :items="workdays"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action" v-if="canUpdate">
                        <i class="mr-3 far fa-edit" @click="editWorkday(item)"></i>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'WorkDay',

    components: {

    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalWorkday: 0,
            workdays: [],
            canUpdate: false
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.workday.bureau'), value: 'bureau', width: '25%' },
                { text: this.$vuetify.lang.t('$vuetify.workday.acronym'), value: 'acronym', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.workday.workDay'), value: 'work_day', width: '15%', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.workday.totalEmployee'), value: 'total_employee', width: '12%', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.workday.updatedDate'), value: 'recent_update', width: '12%', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.workday.createdDate'), value: 'created_at', width: '12%', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.workday.action'), value: 'action', width: '5%', sortable: false, align: 'center' }
            ]
        }
    },

    methods: {
        async searchWorkdays () {
            this.options.page = 1
            await this.getWorkdays()
        },

        async getWorkdays () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `workdays?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.workdays = res.data.data
                this.totalWorkday = res.data.total
            }
            this.loading = false
        },

        editWorkday (item) {
            this.$router.push({ name: 'EditWorkday', params: { id: item.id } })
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.TIMETABLE_SETTING.UPDATE)
    },

    watch: {
        options: {
            async handler () {
                await this.getWorkdays()
            },
            deep: true
        },

        '$vuetify.lang.current': {
            handler: async function () {
                await this.getWorkdays()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 340px;
    }
}

.action {
    display: flex;
    align-items: center;
}
</style>
